<template>

  <div>

    <v-stepper v-model="curStep" non-linear :alt-labels="false" light>

      <!-- Stepper Headers -->
      <v-stepper-header class="grey lighten-3">

        <v-stepper-step editable :complete="curStep > 1" step="1">Use Type</v-stepper-step>

        <v-divider></v-divider>
        <v-stepper-step editable :complete="curStep > 2" step="2">Speed</v-stepper-step>

        <v-divider></v-divider>
        <v-stepper-step editable :complete="curStep > 3" step="3">Capacity</v-stepper-step>

        <v-divider></v-divider>
        <v-stepper-step editable step="4">Community</v-stepper-step>

      </v-stepper-header>

      <slot name="back-next"></slot>

      <!-- Stepper Items -->
      <v-stepper-items>

        <v-stepper-content step="1">
          <h3 class="headline">Describe the type of business:</h3>
          <WizardStep selection-type="businessType"
                      :items="businessType"
                      class="fill-height"
                      @increment-step="incrementStep"></WizardStep>
        </v-stepper-content>

        <v-stepper-content step="2">
          <h3 class="headline">Target an optimal speed per user:</h3>
          <WizardStep selection-type="businessSpeed"
                      :items="businessSpeed"
                      :category="selectedBusinessType"
                      @increment-step="incrementStep"></WizardStep>
        </v-stepper-content>

        <v-stepper-content step="3">

          <h3 class="headline">Indicate expected capacity:</h3>
          <!--          <WizardStep selection-type="businessSpeed"-->
          <!--                      :items="businessSpeed"-->
          <!--                      :category="selectedBusinessType"-->
          <!--                      @increment-step="incrementStep"></WizardStep>-->

          <v-container fluid grid-list-xl v-if="preferences.businessType">

            <v-layout align-center fill-height class="ma-5">

              <v-flex>

                Adjust # of {{usersLabel}}

                <v-slider
                  v-model="defaultCapacity"
                  prepend-icon="mdi-minus-circle-outline"
                  append-icon="mdi-plus-circle-outline"
                  @click:prepend="defaultCapacity -= 5"
                  @click:append="defaultCapacity += 5"
                  :min="0"
                  :max="300"
                  :step="1"
                  hint="Drag slider to rapidly adjust capacity."
                  persistent-hint
                ></v-slider>

              </v-flex>

              <v-flex v-if="preferences.businessType.value === 'lodging'">

                <v-sheet color="grey lighten-3" class="text-center pa-3">
                  <h6 class="subtitle-1 pa-0 ma-0">Number of Beds</h6>

                  <h6 class="display-2 pa-0 ma-0">
                    <v-btn icon text @click="defaultCapacity -= 1">
                      <v-icon large>mdi-minus-circle-outline</v-icon>
                    </v-btn>
                    <div class="d-inline-block" style="min-width: 100px;">{{defaultCapacity}}</div>
                    <v-btn icon text @click="defaultCapacity += 1">
                      <v-icon large>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                  </h6>

                </v-sheet>

              </v-flex>

              <v-flex v-if="preferences.businessType.value === 'lodging'">

                <v-sheet color="grey lighten-3" class="text-center pa-3">
                  <h6 class="subtitle-1 pa-0 ma-0">Average Occupancy (%)</h6>

                  <h6 class="display-2 pa-0 ma-0">
                    <v-btn icon text @click="avgOccupancy -= 1">
                      <v-icon large>mdi-minus-circle-outline</v-icon>
                    </v-btn>
                    <div class="d-inline-block" style="min-width: 100px;">{{avgOccupancy}}</div>
                    <v-btn icon text @click="avgOccupancy += 1">
                      <v-icon large>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                  </h6>

                </v-sheet>

              </v-flex>

              <v-flex v-if="preferences.businessType.value === 'lodging'">
                <v-sheet color="info white--text" class="text-center pa-3">
                  <h6 class="subtitle-1 pa-0 ma-0">Total Expected Capacity</h6>
                  <h6 class="display-2 pa-0 ma-0">
                    {{calculatedCapacity}}
                  </h6>
                </v-sheet>
              </v-flex>

              <v-flex v-else>
                <v-sheet color="info white--text" class="text-center pa-3">
                  <h6 class="subtitle-1 pa-0 ma-0">Total Expected Capacity</h6>

                  <h6 class="display-2 pa-0 ma-0">
                    <v-btn icon text @click="defaultCapacity -= 1">
                      <v-icon color="white" large>mdi-minus-circle-outline</v-icon>
                    </v-btn>
                    <div class="d-inline-block" style="min-width: 100px;">
                      {{calculatedCapacity}}
                    </div>
                    <v-btn icon text @click="defaultCapacity += 1">
                      <v-icon color="white" large>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                  </h6>
                </v-sheet>
              </v-flex>

            </v-layout>

          </v-container>

          <!--          <v-btn dark color="info" class="mt-4" block x-large @click="curStep += 1">-->
          <!--            Continue-->
          <!--          </v-btn>-->

        </v-stepper-content>

        <v-stepper-content step="4">
          <WizardLocations selection-type="locations"
                           :items="locations"
                           :step="curStep"
                           @increment-step="incrementStep">
          </WizardLocations>
        </v-stepper-content>

      </v-stepper-items>

    </v-stepper>

  </div>

</template>

<script>
import WizardMixin from '../views/Wizard.Mixin';
import WizardLocations from '../components/wizard/Wizard.Locations';

export default {

  name: 'Wizard.Business',

  components: { WizardLocations, },

  mixins: [WizardMixin],

  data() {
    return {
      totalSteps: 4,
      businessType: this.$store.getters.businessType,
      businessSpeed: this.$store.getters.businessSpeed,
      defaultCapacity: 15,
      avgOccupancy: 50,
    };
  },

  mounted() {
    this.finalizeUserCountSelection();
  },

  watch: {

    calculatedCapacity() {
      this.finalizeUserCountSelection();
    },

  },

  computed: {

    selectedBusinessType() {
      return this.preferences.businessType;
    },

    preferences() {
      return this.$store.state.wizard.preferences;
    },

    locations() {
      return this.$store.getters.locationsFiltered;
    },

    usersLabel() {
      if (this.preferences.businessType) {
        switch (this.preferences.businessType.value) {
          case 'barrestaurant':
            return 'Seats';
          case 'coffeeshop':
            return 'Seats';
          case 'officeretail':
            return 'Workspaces';
          case 'lodging':
            return 'Beds';
          default:
            return 'Users';
        }
      }
      return '';
    },

    calculatedCapacity() {
      if (this.preferences.businessType.value === 'lodging') {
        return Math.round((this.avgOccupancy / 100) * this.defaultCapacity);
      }
      return this.defaultCapacity;
    }

  },

  methods: {

    finalizeUserCountSelection() {
      const value = {
        value: 'capacity',
        text: 'Capacity',
        number: this.calculatedCapacity,
        iconCount: this.calculatedCapacity,
        mdIcon: 'person',
      };
      this.$store.dispatch('setPreferences', {
        ...this.preferences,
        capacity: value,
      });
    },

  },

};

</script>
